import React, { Component } from 'react';
import Tabs from './Tabs/Tabs';
import _ from 'lodash';

class Step2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [],
            positioningData: [],
        };
    }

    createTab = (data) => {
        let tabs = [ ...this.state.tabs];
        tabs.push({
            groupId: data.groupId,
            groupName: data.groupName,
            segmentId: data.segmentId,
            segmentName: data.segmentName,
        });

        this.setState({
            tabs,
            newItem: {
                segmentId: data.segmentId,
                groupId: data.groupId,
            }
        });
        this.createTabClose();
    }

    onChangeValu = (e, type, data, groupId, segmentId) => {
        let value = e.target.value;
        let positioningData = [...this.state.positioningData];

        if(!data){
            positioningData.push({
                //[type] : value,
                forWhome: '',
                brand: '',
                isThe: '',
                that: '',
                because: '',
                soThat: '',
                groupId : groupId,
                segmentId : segmentId
            })
            positioningData[0][type] = value
        }
        if(data){
            let item = positioningData.find(r => r.segmentId === segmentId &&  r.groupId === groupId);
            item[type] = value
        }

        this.setState({ positioningData })
    }

    componentWillMount() {
        let customerSegmentData ={
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData ={
            projectId: this.props.projectId,
            type: 'compete'
        }
        let positioningStatementData = {
            projectId: this.props.projectId,
            type: 'positioning'
        }

        this.props.getPositioningStatement(positioningStatementData);
        this.props.getCompete(competeData);
        this.props.getCustomerSegment(customerSegmentData);
    }

    componentWillReceiveProps(nextProps) {

        if( nextProps.positioningStatement.getPositioningStatementData.Items && _.isEmpty(this.state.positioningData)) {

            if (!nextProps.positioningStatement.getPositioningStatementFetching && !_.isEmpty(nextProps.positioningStatement.getPositioningStatementData.Items) && !_.isEmpty(nextProps.compete.customerSegmentData)) {
                let tabs = [ ...this.state.tabs];
                let oldGroupId = null;
                nextProps.positioningStatement.getPositioningStatementData.Items[0].positioning.map(item=>{
                    let customerSegmentItem = nextProps.compete.customerSegmentData.find(r => r.groupId === item.groupId);
                    let segmentData = customerSegmentItem.segments.find(r => r.segmentId === item.segmentId);
                    tabs.push({
                        groupId: item.groupId,
                        groupName: customerSegmentItem.groupName,
                        segmentId: item.segmentId,
                        segmentName: segmentData.name
                    });
                });

                this.setState({
                    positioningData: nextProps.positioningStatement.getPositioningStatementData.Items[0].positioning,
                    editedData: true,
                    createdData : false,
                    tabs: _.uniqBy(tabs, v => [v.groupId, v.segmentId].join())
                });
            }

            if( _.isEmpty(nextProps.positioningStatement.getPositioningStatementData.Items) && !this.state.createdData){
                this.setState({createdData : true, editedData: false })
            }

        }

        if(!nextProps.positioningStatement.createPositioningStatementFetching  && nextProps.positioningStatement.createPositioningStatementData && nextProps.positioningStatement.createPositioningStatementData.statusCode === 200 && this.props.groupStepState === 2 && this.state.goNextStep) {
            this.props.groupStateNext();
        }
    }

    onNextButtonClick = () => {
        if (this.state.editedData) {
            let body = {
                id: this.props.positioningStatement.getPositioningStatementData.Items[0].id,
                projectId: this.props.projectId,
                type: "positioning",
                positioning: this.state.positioningData
            };

            this.setState({ goNextStep : true });
            this.props.editPositioningStatement(body);
        }
    };

    positioningStatementErrorModal = () => {
        this.setState({ positioningStatementErrorState  : !this.state.positioningStatementErrorState })
    };

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-three arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-three arrow-step active-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-three arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    { (!this.props.compete.competeFetching &&  (!this.props.compete.createAbilityOfCompeteFetching && !this.state.deleteItemProsccess) ) &&
                    <div className='row'>
                        <div className="col-md-8">
                            <div className="criteria-title-box">
                                <h5>Positioning Statement</h5>
                                <span>Fill in the items.</span>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className='card'>
                                <div className='card-body'>
                                    <Tabs
                                        tabs={this.state.tabs}
                                        createTabModal={this.createTabModal}
                                        compete={this.props.compete}
                                        positioningData={this.state.positioningData}
                                        onChangeValu={this.onChangeValu}
                                        tabStep={this.props.tabStep}
                                        onTabChange={this.props.onTabChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div>
                                    <div className='btn empty-btn default' onClick={() => this.props.groupStateBack()}>Back</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        )
    }
}

export default Step2;



// WEBPACK FOOTER //
// ./src/components/PositioningStatement/Step2/Step2.jsx